// resolve debugging error "Uncaught ReferenceError ReferenceError: global is not defined"
(window as any).global = window;

/***************************************************************************************************
 * APPLICATION IMPORTS
 */

import { Buffer } from 'buffer';

// @ts-ignore
window.Buffer = Buffer;
